module.exports = __webpack_public_path__ + "static/img/good1.71ccfaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/good1.png
// module id = zgjr
// module chunks = 1